import { default as React } from 'react';

import { Button, Row } from 'antd';
import { isConPlatform } from 'utils';

export const renderEmailSubscription = (formatMessage: any) => {
  return (
    <Row>
      <Row justify="center" className="subscribe-modal__email-subscribe-title">
        {formatMessage({
          id: 'page.account-newsletter.email-subscription-title',
        })}
      </Row>
      <Row justify="center" className="subscribe-modal__text">
        {formatMessage({
          id: 'page.account-newsletter.email-subscription-text',
        })}
      </Row>
    </Row>
  );
};

export const newsletterModalContent = (
  loading: boolean,
  handleSubscription: () => void,
  formatMessage: any
) => {
  return (
    <Row>
      <Row
        justify="center"
        className={`subscribe-modal__title ${
          isConPlatform ? 'con__' : 'pin__'
        }subscribe-modal__title`}
      >
        {formatMessage({
          id: 'page.account-newsletter.unsubscribe-modal-title',
        })}
      </Row>
      <Row className="small-body subscribe-modal__text">
        {formatMessage({
          id: 'page.account-newsletter.unsubscribe-modal-message',
        })}
      </Row>
      <Row justify="center">
        <Button
          loading={loading}
          className="btn-primary btn-primary--black subscribe-modal__button"
          onClick={() => handleSubscription()}
        >
          {formatMessage({ id: 'button.unsubscribe' })}
        </Button>
      </Row>
    </Row>
  );
};
